module.exports = __webpack_public_path__ + "static/notification-21fceddfbaa702f899b0a5cc55d8d666.png";